import Input from '@vtex/styleguide/lib/Input';

function VtexInput(props) {
	return (
		<label className="vtex-input w-100">
			<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
				<input
					onChange={props.onChange}
					className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-input vtex-styleguide-9-x-input br2  br-0 br--left  w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body pl5 "
					placeholder="O que procura?"
					type="text"
					defaultValue=""
				/>
				{props.suffix && (
					<span className="c-muted-2 fw5 flex items-center t-body bg-base  vtex-input__suffix br2 bl-0 br--right pr5 pl3 ">
						{props.suffix}
					</span>
				)}
			</div>
		</label>
	);
}

export default VtexInput;
